import React from 'react'
import { MessageListProvider } from './Context'
import { Layout } from './Layout'

export const Page = () => {
  return (
    <MessageListProvider>
      <Layout />
    </MessageListProvider>
  )
}
